/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=6751386a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6751386a&lang=scss"

import exportComponent from "D:\\project\\2023-fish\\fish\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__